if(typeof coreApis === 'undefined') { var e = new Error("Cannot find module 'coreApis.style'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = coreApis.style;